import React, { useState, useContext, useEffect, useRef } from 'react';
import CheckBox from '@mui/icons-material/CheckBox';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import {
  Grid,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/Context';

import toast from 'react-hot-toast';

import { SocketContext } from '../../context/SocketContext';

import { useTranslation } from 'react-i18next';

import { useLocation } from 'react-router-dom';

import TableLoader from '../../components/TableLoader/TableLoader';
import '../../assets/css/buttons.css';

const headerCellSx = {
  backgroundColor: '#151d3b',
  color: '#8fa3d4',
  fontWeight: 700,
  fontSize: '13px',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  borderBottom: '2px solid #2a3a6e',
  whiteSpace: 'nowrap',
};

const PROVIDER_COLORS = {
  CH: { bg: '#0d3b7a', color: '#90caf9' },
  WG: { bg: '#4a1070', color: '#ce93d8' },
  'OK D.': { bg: '#004d40', color: '#80cbc4' },
};

function BilletHistorikk() {
  //* Was here for the tables
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [rows, setRows] = useState(false);
  const [rowsFiltered, setRowsFiltered] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [confirmModal, setConfirmModal] = useState(null);

  //* Redirect to login if not logged in
  useEffect(() => {
    if (!isLogin) {
      navigate('/login');
    }
  }, []);

  //* Manage enter from the scan
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const dateInputRef = useRef(null);

  const [searchType, setSearchType] = useState('ticketID');
  const [searchValue, setSearchValue] = useState('');
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const { t } = useTranslation();

  const searchTypeLabel = {
    username: t('sisteSalgs.username'),
    name: t('pep.name'),
    ticketID: t('apneBilleter.ticketID'),
    provider: t('sales.provider'),
    open: t('sales.openTickets'),
    closed: t('sales.closedTickets'),
    time: t('sales.time'),
  };
  const navigate = useNavigate();
  const {
    isLogin,
    isBlocking,
    BlockingScreen,
    hall,
    operator,
    session,
    printer,
    updateIsLoadingScreen,
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 1100);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    socket.emit('ticketList', { bingoName: hall, date: new Date().toISOString().slice(0, 10) });
  }, [hall]);

  const location = useLocation();

  //* Socket setup
  const { socket } = useContext(SocketContext);
  useEffect(() => {
    const handleTicketList = (data) => {
      setRows(data || []);
      setIsLoading(false);
    };

    socket.on('ticketList', handleTicketList);

    return () => {
      socket.off('ticketList', handleTicketList);
    };
  }, [socket]);

  const pendingCloseMainID = useRef(null);

  const markTicketClosed = (mainID) => {
    const update = (list) =>
      list
        ? list.map((t) =>
            String(t.mainID) === String(mainID) ? { ...t, isOpen: 0 } : t
          )
        : list;
    setRows((prev) => update(prev));
    setRowsFiltered((prev) => update(prev));
  };

  useEffect(() => {
    const handleCashoutTicket = (data) => {
      updateIsLoadingScreen(false);
      setConfirmModal(null);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      markTicketClosed(pendingCloseMainID.current);
    };

    const handleCashoutWG = (data) => {
      updateIsLoadingScreen(false);
      setConfirmModal(null);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      markTicketClosed(pendingCloseMainID.current);
    };

    socket.on('cashoutTicket', handleCashoutTicket);
    socket.on('cashoutWG', handleCashoutWG);

    return () => {
      socket.off('cashoutTicket', handleCashoutTicket);
      socket.off('cashoutWG', handleCashoutWG);
    };
  }, [socket]);

  function convertToMySQLDateTime(isoString) {
    const date = new Date(isoString);

    // Padding function to add leading zeros if necessary
    const pad = (number) => (number < 10 ? '0' + number : number);

    // Format the date using UTC methods
    const year = date.getUTCFullYear();
    const month = pad(date.getUTCMonth() + 1); // getUTCMonth() returns month from 0-11
    const day = pad(date.getUTCDate());
    const hours = pad(date.getUTCHours());
    const minutes = pad(date.getUTCMinutes());
    const seconds = pad(date.getUTCSeconds());

    return `${hours}:${minutes}:${seconds}`;
  }

  const handleCloseTicket = (row) => {
    return;
    setConfirmModal(row);
  };

  const confirmClose = () => {
    const row = confirmModal;
    console.log('Close ticket:', row);

    pendingCloseMainID.current = row.mainID;
    updateIsLoadingScreen(true);

    const userInfo = {
      '7 digit PIN': row.user7Pincode,
      id: row.userID,
      username: row.ticketUsername,
    };

    if (row.provider === 'CH') {
      const dataNewTicket = {
        name: 'Avbryt Ny Billett - CH',
        amount: parseInt(row.saldoInit),
        type: 'transaction',
      };
      const data = {
        transactions: [dataNewTicket],
        operator: operator,
        bingoName: hall,
        sessionID: session,
        provider: row.provider,
        description: 'Avbryt Ny Billett',
        amount: parseInt(row.saldoInit),
        user7Pincode: row.user7Pincode,
        userInfo: userInfo,
        isChild: true,
        usePrinter: false,
        useSMS: false,
        printBarcode: false,
        qrMessage: false,
        session: session,
        playerID: row.userID,
        cashoutType: 'cash_from_wallet',
        ticketID: row.ticketID,
        ticketUsername: row.ticketUsername,
        ticket7Pincode: row.ticket7Pincode,
        isPrintedByCH: true,
        action: 'cashoutTicket',
      };
      socket.emit('cashoutTicket', data);
      return;
    }

    if (row.provider === 'WG') {
      socket.emit('cashoutWG', {
        operator: operator,
        bingoName: hall,
        sessionID: session,
        userInfo: userInfo,
        amount: parseInt(row.saldoInit),
        provider: row.provider,
        description: 'Avbryt Ny Billett',
        wgID: row.wgID,
        action: 'cashoutWG',
        printer: printer,
      });
      return;
    }

    // OK — to be implemented
    updateIsLoadingScreen(false);
    setConfirmModal(null);
  };

  const handleSearch = () => {
    setIsLoading(true);
    socket.emit('ticketList', { bingoName: hall, date });
  };

  useEffect(() => {
    if (!rows) return;
    let filtered = Array.isArray(rows) ? [...rows] : [];
    const guestLabel = t('kiosk.guest').toLowerCase();
    if (searchValue.trim() && searchType !== 'open' && searchType !== 'closed') {
      const val = searchValue.trim().toLowerCase();
      if (searchType === 'username') {
        filtered = filtered.filter((row) => {
          const effective = row.username && row.username !== '' ? row.username.toLowerCase() : guestLabel;
          return effective.includes(val);
        });
      } else if (searchType === 'name') {
        filtered = filtered.filter((row) => {
          const effective = row.name && row.name !== '' ? row.name.toLowerCase() : guestLabel;
          return effective.includes(val);
        });
      } else if (searchType === 'ticketID') {
        filtered = filtered.filter((row) => String(row.mainID).includes(val));
      } else if (searchType === 'provider') {
        filtered = filtered.filter((row) => row.provider?.toLowerCase().includes(val));
      } else if (searchType === 'time') {
        filtered = filtered.filter((row) => convertToMySQLDateTime(row.date).includes(val));
      }
    }
    if (searchType === 'open') {
      filtered = filtered.filter((row) => row.isOpen === 1);
    } else if (searchType === 'closed') {
      filtered = filtered.filter((row) => row.isOpen === 0);
    }
    setRowsFiltered(filtered);
  }, [rows, searchType, searchValue]);

  return (
    <>
      {isBlocking && <BlockingScreen />}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <Grid
            container
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {/* SEARCH BAR */}
            <Grid
              item
              xs={12}
              sx={{
                height: '190px',
                maxHeight: '190px',
                display: 'flex',
                alignItems: 'center',
                px: 3,
                gap: 2,
                borderBottom: '1px solid #2a3a6e',
              }}
            >
              <FormControl
                sx={{
                  minWidth: 200,
                  backgroundColor: '#232a45',
                  borderRadius: '4px',
                }}
              >
                <InputLabel
                  sx={{ color: 'white !important', fontSize: '20px' }}
                >
                  {t('ticketHistoric.searchType')}
                </InputLabel>
                <MuiSelect
                  value={searchType}
                  label={t('ticketHistoric.searchType')}
                  onChange={(e) => setSearchType(e.target.value)}
                  sx={{
                    color: 'white',
                    height: '90px',
                    fontSize: '24px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#365ab8',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#fcad89',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#fcad89',
                    },
                    '& .MuiSvgIcon-root': { color: 'white' },
                  }}
                >
                  <MenuItem value="username">{t('sisteSalgs.username')}</MenuItem>
                  <MenuItem value="name">{t('pep.name')}</MenuItem>
                  <MenuItem value="ticketID">{t('apneBilleter.ticketID')}</MenuItem>
                  <MenuItem value="provider">{t('sales.provider')}</MenuItem>
                  <MenuItem value="open">{t('sales.openTickets')}</MenuItem>
                  <MenuItem value="closed">{t('sales.closedTickets')}</MenuItem>
                  <MenuItem value="time">{t('sales.time')}</MenuItem>
                </MuiSelect>
              </FormControl>

              <TextField
                sx={{
                  flex: 1,
                  backgroundColor: '#232a45',
                  '& .MuiOutlinedInput-root': {
                    height: '90px',
                    '& fieldset': { borderColor: '#365ab8' },
                    '&:hover fieldset': { borderColor: '#fcad89' },
                    '&.Mui-focused fieldset': { borderColor: '#fcad89' },
                  },
                  '& input': { color: 'white', fontSize: '24px' },
                  '& label': { color: 'white !important', fontSize: '20px' },
                  '& label.Mui-focused': { color: 'white !important' },
                  '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
                    transform: 'translate(14px, 30px) scale(1)',
                  },
                }}
                label={searchTypeLabel[searchType] || ''}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                autoFocus
                autoComplete="off"
                variant="outlined"
                inputRef={inputRef}
                disabled={searchType === 'open' || searchType === 'closed'}
              />

              <TextField
                type="date"
                label={t('sales.searchByDate')}
                value={date}
                onChange={(e) => setDate(e.target.value)}
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                inputRef={dateInputRef}
                onClick={() => dateInputRef.current?.showPicker?.()}
                sx={{
                  width: '310px',
                  backgroundColor: '#232a45',
                  cursor: 'pointer',
                  '& .MuiOutlinedInput-root': {
                    height: '90px',
                    cursor: 'pointer',
                    '& fieldset': { borderColor: '#365ab8' },
                    '&:hover fieldset': { borderColor: '#fcad89' },
                    '&.Mui-focused fieldset': { borderColor: '#fcad89' },
                  },
                  '& input': {
                    color: 'white',
                    fontSize: '24px',
                    colorScheme: 'dark',
                    cursor: 'pointer',
                  },
                  '& label': { color: 'white !important', fontSize: '20px' },
                  '& label.Mui-focused': { color: 'white !important' },
                }}
              />

              <Button
                variant="contained"
                onClick={handleSearch}
                sx={{
                  height: '90px',
                  minWidth: '160px',
                  fontSize: '24px',
                  fontWeight: 'bold',
                  backgroundColor: '#009e82',
                  textTransform: 'uppercase',
                  flexShrink: 0,
                }}
              >
                {t('menu.search')}
              </Button>
            </Grid>

            {/*TABLE*/}
            <Grid
              item
              xs={12}
              sx={{
                width: '100%',
                padding: '10px',
                height: '100%',
              }}
            >
              {isLoading ? (
                <TableLoader />
              ) : (
                <TableContainer
                  component={Paper}
                  className="sp-scroll"
                  sx={{
                    maxHeight: 'calc(100% - 190px)',
                    marginBottom: '190px',
                    overflowY: 'auto',
                    backgroundColor: '#1a2240',
                  }}
                >
                  <Table
                    sx={{
                      color: 'white',
                      background: '#1a2240',
                    }}
                    stickyHeader
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('sales.dateLastRecord')}
                        </TableCell>

                        <TableCell align="center" sx={headerCellSx}>
                          {t('apneBilleter.username')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('pep.name')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('apneBilleter.ticketID')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('sales.provider')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('sales.platform')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('sales.ticketClosed')}
                        </TableCell>

                        <TableCell align="center" sx={headerCellSx}>
                          {t('ticketHistoric.saldoInit')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}>
                          {t('ticketHistoric.saldoEnd')}
                        </TableCell>
                        <TableCell align="center" sx={headerCellSx}></TableCell>
                      </TableRow>
                    </TableHead>
                    {rowsFiltered && (
                      <TableBody>
                        {rowsFiltered.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                              '&:nth-of-type(odd)': {
                                backgroundColor: '#232a45',
                              },
                              '&:nth-of-type(even)': {
                                backgroundColor: '#1a2036',
                              },
                            }}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                            >
                              {convertToMySQLDateTime(row.date)}
                            </TableCell>

                            <TableCell align="center">{row.username && row.username !== '' ? row.username : t('kiosk.guest')}</TableCell>
                            <TableCell align="center">{row.name && row.name !== '' ? row.name : t('kiosk.guest')}</TableCell>
                            <TableCell align="center">{row.mainID}</TableCell>
                            <TableCell align="center">
                              {row.provider ? (
                                <Chip
                                  label={row.provider}
                                  size="small"
                                  sx={{
                                    backgroundColor: (
                                      PROVIDER_COLORS[row.provider] || {
                                        bg: '#263238',
                                        color: '#b0bec5',
                                      }
                                    ).bg,
                                    color: (
                                      PROVIDER_COLORS[row.provider] || {
                                        bg: '#263238',
                                        color: '#b0bec5',
                                      }
                                    ).color,
                                    fontWeight: 700,
                                    fontSize: '12px',
                                    height: '26px',
                                  }}
                                />
                              ) : (
                                '—'
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <Chip
                                label={
                                  row.platform === 'kiosk'
                                    ? t('sales.platformKiosk')
                                    : t('sales.platformCashier')
                                }
                                size="small"
                                sx={{
                                  backgroundColor:
                                    row.platform === 'kiosk'
                                      ? '#3e2723'
                                      : '#263238',
                                  color:
                                    row.platform === 'kiosk'
                                      ? '#bcaaa4'
                                      : '#b0bec5',
                                  fontWeight: 600,
                                  fontSize: '12px',
                                  height: '26px',
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Chip
                                label={
                                  row.isOpen === 0
                                    ? t('sales.closedTickets')
                                    : t('sales.openTickets')
                                }
                                size="small"
                                sx={{
                                  backgroundColor:
                                    row.isOpen === 0 ? '#1b4020' : '#7a3800',
                                  color:
                                    row.isOpen === 0 ? '#69f0ae' : '#ffcc80',
                                  fontWeight: 700,
                                  fontSize: '12px',
                                  height: '26px',
                                  border:
                                    row.isOpen === 0
                                      ? '1px solid #69f0ae44'
                                      : '1px solid #ffcc8044',
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Box sx={{ color: '#8fa3d4', fontWeight: 600 }}>
                                {row.saldoInit ?? '—'}
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box sx={{ color: '#8fa3d4', fontWeight: 600 }}>
                                {row.saldoEnd ?? '—'}
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              {row.isOpen === 1 && date === new Date().toISOString().slice(0, 10) && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="error"
                                  onClick={() => handleCloseTicket(row)}
                                >
                                  {t('sales.closeTicket')}
                                </Button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {confirmModal && (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <div
                className="react-confirm-alert-body"
                style={{ width: '1000px' }}
              >
                <h1>{t('sales.closeTicketConfirmTitle')}</h1>
                <p>{t('sales.closeTicketConfirmMessage')}</p>
                <p>
                  <strong>{confirmModal.name}</strong> — {confirmModal.mainID}
                </p>

                <div
                  className="react-confirm-alert-button-group"
                  style={{ marginTop: '55px' }}
                >
                  <button
                    className="btn-custom-yes"
                    onClick={confirmClose}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                    {t('sales.confirm')}
                  </button>
                  <button
                    className="btn-custom-no"
                    onClick={() => setConfirmModal(null)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />
                    {t('sales.cancel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BilletHistorikk;
